import authConfig from "../auth.config";

export function debugLog(message: string, data?: object): void {
  if (authConfig.debug) {
    const timestamp = new Date().toISOString();
    const prefix = `[🔒Auth-Client ${timestamp}]`;

    if (data !== undefined) {
      console.log(`${prefix} ${message}`, data);
    } else {
      console.log(`${prefix} ${message}`);
    }
  }
}

export function debugError(message: string, error?: unknown): void {
  if (authConfig.debug) {
    const timestamp = new Date().toISOString();
    const prefix = `[🔒Auth-Client ${timestamp}] ERROR:`;

    if (error !== undefined) {
      console.error(`${prefix} ${message}`, error);
    } else {
      console.error(`${prefix} ${message}`);
    }
  }
}
